import {
  FirestoreGenerationStatus,
  FirestoreProductActions,
} from "reedy-data/models";
import { IProduct } from "integrations/firebase/collections";

export interface GenerationStatuses {
  keywordsStatus: FirestoreGenerationStatus;
  subjectsStatus: FirestoreGenerationStatus;
  descriptionStatus: FirestoreGenerationStatus;
}

const DEFAULT_STATUSES: GenerationStatuses = {
  subjectsStatus: FirestoreGenerationStatus.IMPORTED,
  keywordsStatus: FirestoreGenerationStatus.IMPORTED,
  descriptionStatus: FirestoreGenerationStatus.IMPORTED,
};

export const ERROR_STATUSES: GenerationStatuses = {
  subjectsStatus: FirestoreGenerationStatus.ERROR,
  keywordsStatus: FirestoreGenerationStatus.ERROR,
  descriptionStatus: FirestoreGenerationStatus.ERROR,
};

const getDescriptionGenerationStatus = (
  actions: FirestoreProductActions | undefined,
): FirestoreGenerationStatus => {
  const descActions = actions?.descriptions?.actions;
  if (!descActions) return FirestoreGenerationStatus.IMPORTED;

  const allGenerationStatuses = Object.values(descActions)
    .map((action) => action?.generate?.status)
    .filter((status) => status !== undefined);

  if (allGenerationStatuses.length === 0) {
    return FirestoreGenerationStatus.IMPORTED;
  }

  if (
    allGenerationStatuses.some(
      (status) => status === FirestoreGenerationStatus.ERROR,
    )
  ) {
    return FirestoreGenerationStatus.ERROR;
  }

  if (
    allGenerationStatuses.every(
      (status) =>
        status === FirestoreGenerationStatus.COMPLETED ||
        status === FirestoreGenerationStatus.CANCELLED,
    )
  ) {
    return FirestoreGenerationStatus.COMPLETED;
  }

  if (
    allGenerationStatuses.some(
      (status) =>
        status === FirestoreGenerationStatus.REQUESTED ||
        status === FirestoreGenerationStatus.GENERATING ||
        status === FirestoreGenerationStatus.GENERATED ||
        status === FirestoreGenerationStatus.PROCESSING,
    )
  ) {
    return FirestoreGenerationStatus.GENERATING;
  }

  return FirestoreGenerationStatus.IMPORTED;
};

export const getStatusesFromActions = (
  actions: FirestoreProductActions | undefined,
): GenerationStatuses => {
  if (!actions) return DEFAULT_STATUSES;

  return {
    subjectsStatus:
      actions.thema?.actions?.generate?.status ??
      FirestoreGenerationStatus.IMPORTED,
    keywordsStatus:
      actions.keywords?.actions?.generate?.status ??
      FirestoreGenerationStatus.IMPORTED,
    descriptionStatus: getDescriptionGenerationStatus(actions),
  };
};

export const getBadgeStatusFromRow = (
  product: IProduct | undefined,
): GenerationStatuses => {
  if (!product) return DEFAULT_STATUSES;
  return getStatusesFromActions(product.actions);
};
